import { Branding, BrandingDisabledIf, DisabledPrompt, useModel } from "bcms-react";
import { MainNavItem, MainNavMenuItem } from "../..";
import "./styles.css";
/**
 * @name BID1224MainNavItems
 * @function
 * @extends React.Component
 * @exported true
 * @description The main component for navigation for BID 1224.
 * @example
 * export default function Component() {
 *  return (
 *      <div>
 *          <BID1224MainNavView/>
 *      </div>
 *  );
 * }
 */
export default function BID1224MainNavItems(props) {
    const { branding, demos } = useModel();
    const { options } = branding;

    // START: Branded links declared here and returned in the component.
    const paymentsLabel = "Bill Pay";  
    const paymentLink = options.rxp17_courseID_abi22 === null ? <DisabledPrompt><MainNavItem label={paymentsLabel}  data-point="Nav_Payments" /></DisabledPrompt> : <MainNavItem label={ paymentsLabel }  route="/payments" data-point="Nav_Payments" />;
    const externalTransfersLink = options.tn19_courseID_abi22 === null ? <DisabledPrompt><MainNavMenuItem label="External Transfers"  data-point="Nav_External_Transfers" /></DisabledPrompt> : <MainNavMenuItem label="External Transfers" route="/externalTransfers" data-point="Nav_External_Transfers" />;

    const openAccount = () => {
        let origVersion = branding.options.orig_version_abi22;
        if(origVersion !== "ORIG19") origVersion = "ORIG20";
        window.open(demos[origVersion], "_blank");
    };
                               
    const newAccountsLink =  <MainNavItem label="Accounts" data-point="Nav_Accounts" activeRoutes={["/accountdetails/*", "/creditScore", "/stopPayment", "/download"]}>
                                <MainNavMenuItem label="Account Summary" route="/accountSummary" data-point="Nav_Account_Summary" />
                                <MainNavMenuItem label="Stop Payments" route="/stopPayment" data-point="Nav_Stop_Payments" />
                                <MainNavMenuItem className="download-transaction-history-link" label="Download Transaction History" route="/download" data-point="Nav_Download" />
                                <DisabledPrompt>
                                    <MainNavMenuItem label="Statements" route="/statements" data-point="Nav_eStatements_Notices" />
                                </DisabledPrompt>
                            </MainNavItem>;

    const alertsLink = <BrandingDisabledIf id="notifi_version_abi22"  exp={(val) => val !== "Disabled" }>               
                        <MainNavItem label="Manage Alerts" route="/notifications" data-point="Nav_Manage_Alerts" />
                    </BrandingDisabledIf>;   

    const openAnAccount = <DisabledPrompt>
                            <MainNavItem label="Open an Account" data-point="Nav_Open_Account" onClick={ openAccount } />
                        </DisabledPrompt>;

    const cardsLink = <MainNavItem label="Cards" data-point="Nav_Cards">
                        <DisabledPrompt>
                            <MainNavMenuItem label="Credit Cards" data-point="Nav_Credit_Cards" />
                        </DisabledPrompt>
                        <BrandingDisabledIf id="chw23_courseid_abi22" exp={ value => value !== null && value !== undefined }>
                            <MainNavMenuItem className="debit-card-management-link" label="Debit Card Management" route="/chw23" data-point="Nav_Debit_Card_Management" />
                        </BrandingDisabledIf>
                    </MainNavItem>;

    const newTransfersLink = <MainNavItem label="Transfers" data-point="Nav_Transfers" activeRoutes={[ "/transferActivity/transferHistory", "/externalTransfers" ]} >
                                <MainNavMenuItem label="Make a Transfer" route="/transfers" data-point="Nav_Make_Transfer" />
                                { externalTransfersLink }
                                <MainNavMenuItem label="Transfer Activity" route="/transferActivity/scheduledTransfers" data-point="Nav_Transfer_Activity" />
                            </MainNavItem>;
                            
    const pfmLink = options.pfm21_courseID_abi22 === null
    ? <DisabledPrompt><MainNavItem label="My Finances" data-point="Nav_My_Finances"/></DisabledPrompt> 
    : <MainNavItem label="My Finances" route="/myFinances" data-point="Nav_My_Finances"/>;

    // END: Branded links declared here and returned in the component.

    return (
        <Branding id="bid_abi22" value="1224">
            <div className="flex-container flex-horizontal">
                { newAccountsLink }
                { newTransfersLink }
                { paymentLink }
                { cardsLink }
                { alertsLink }   
                { openAnAccount }   
                { pfmLink }       
            </div>
        </Branding>
    );
}
